import type { CardProps } from './types'

export default function Card({
	image,
	label,
	title,
	url,
	isExternal = false,
	titleSize,
	variant = 'default',
	reserveLabelSpace = true,
}: CardProps) {
	const TitleTag = titleSize
	const aspectClass = variant === 'article' ? 'aspect-3/2' : 'aspect-5/4'

	return (
		<article className="group relative flex flex-col gap-6 w-full h-full text-black-950">
			{url && (
				<a
					href={url}
					className="absolute inset-0 z-10 focus-visible:ring-2 focus-visible:ring-black-950 focus-visible:ring-offset-2"
					aria-label={title || undefined}
					target={isExternal ? '_blank' : undefined}
					rel={isExternal ? 'noopener noreferrer' : undefined}
				/>
			)}

			{image ? (
				<figure className={`w-full ${aspectClass} overflow-hidden rounded-sm`}>
					<img
						src={image.src}
						alt={image.alt}
						className="w-full h-full object-cover transition-opacity duration-200 ease-out group-hover:opacity-90"
					/>
				</figure>
			) : (
				/* Grows to match a same-row sibling's image height; collapses to no extra space when alone */
				<div className="w-full grow" aria-hidden="true" />
			)}

			<div className="flex flex-col gap-2">
				{label ? (
					<p className="body-small uppercase">{label}</p>
				) : reserveLabelSpace ? (
					/* Keeps the label's line box so titles align across cards; same utility so the height tracks .body-small */
					<p className="body-small" aria-hidden="true">&nbsp;</p>
				) : null}
				{title ? (
					/* Semantic level tracks page context via titleSize; visual size is always h4 */
					<TitleTag className="h4 line-clamp-4 group-hover:underline transition-colors duration-200 ease-out">
						{title}
					</TitleTag>
				) : null}
			</div>
		</article>
	)
}
